import React, { useEffect, useState } from 'react';
import { Droplets, ArrowRight } from 'lucide-react';
import { companyInfo } from '../mockData';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      {/* Plataforma 2D lateral izquierda */}
      <div className="platform-2d"></div>

      {/* Imagen lateral derecha con difuminados */}
      <div className="hero-right-image"></div>

      <div className="hero-content">
        <div className="hero-icon-container">
          <Droplets className="hero-icon" size={80} />
        </div>
        <h1 className="hero-title">
          Soluciones profesionales en Filtración y
          <span className="hero-title-highlight"> Tratamientos de Agua</span>
        </h1>
        <p className="hero-description">
          {companyInfo.description}
        </p>
        <div className="hero-buttons">
          <button 
            className="hero-button primary"
            onClick={() => scrollToSection('servicios')}
          >
            Nuestros Servicios
            <ArrowRight size={20} />
          </button>
          <button 
            className="hero-button secondary"
            onClick={() => scrollToSection('ubicacion')}
          >
            Contáctanos
          </button>
        </div>
      </div>
      
      {/* Partículas de agua aumentadas */}
      <div className="hero-decoration">
        <div className="drop drop-1"></div>
        <div className="drop drop-2"></div>
        <div className="drop drop-3"></div>
        <div className="drop drop-4"></div>
        <div className="drop drop-5"></div>
        <div className="drop drop-6"></div>
        <div className="drop drop-7"></div>
        <div className="drop drop-8"></div>
        <div className="drop drop-9"></div>
        <div className="drop drop-10"></div>
        <div className="drop drop-11"></div>
        <div className="drop drop-12"></div>
        <div className="drop drop-13"></div>
        <div className="drop drop-14"></div>
        <div className="drop drop-15"></div>
        <div className="drop drop-16"></div>
        <div className="drop drop-17"></div>
        <div className="drop drop-18"></div>
        <div className="drop drop-19"></div>
        <div className="drop drop-20"></div>
      </div>
    </section>
  );
};

export default Hero;
